
























import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component
export default class ConfirmDialog extends Vue {
  @PropSync('isVisible', { type: Boolean, default: false })
  isModalVisible!: boolean
  @Prop({ default: 'Confirm' })
  title!: string
  @Prop({ required: true })
  content!: string

  @Prop({ default: '21' }) width!: string

  /* Methods */
  onConfirmClicked() {
    this.$emit('confirm')
  }

  onCancelClicked() {
    this.$emit('cancel')
  }
}
